import { useShopI18n } from '../i18n/ShopI18n'
import { useEffect, useState } from 'react'
import { shopArtwork } from './shopArtwork'
import { formatShopAmount } from '../utils/shopFormatters'

export default function GiftCard({ amount, onClaim, daily = false, joker = false, nextBookTime = 0 }: { amount: number; onClaim: () => Promise<void>; daily?: boolean; joker?: boolean; nextBookTime?: number }) {
    const { t, locale } = useShopI18n()
    const [status, setStatus] = useState<'ready' | 'pending' | 'claimed' | 'error'>('ready')
    const [now, setNow] = useState(() => Date.now() / 1000)
    const remaining = Math.max(0, Math.ceil(nextBookTime - now))
    useEffect(() => {
        if (!daily) return
        const timer = window.setInterval(() => setNow(Date.now() / 1000), 1000)
        return () => window.clearInterval(timer)
    }, [daily])
    const waiting = daily && remaining > 0
    const claimed = !daily && status === 'claimed'
    const countdown = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60].map(n => String(n).padStart(2, '0')).join(':')
    const claim = async () => {
        if (status === 'pending' || claimed || waiting) return
        setStatus('pending')
        try { await onClaim(); setStatus('claimed') } catch { setStatus('error') }
    }
    return <article className="shop-card shop-gift-card">
        <span className="shop-badge" data-kind="is-new">{joker ? t('Gratis-Bonus') : daily ? t('Täglicher Bonus') : t('Geschenk')}</span>
        <div className="shop-card-content"><div className="shop-card-art"><img src={joker ? shopArtwork.joker : shopArtwork.gift} alt="" /></div>
            <p className="shop-amount">{formatShopAmount(amount, locale)}</p><p className="shop-unit">{joker ? t('Joker') : t('Chips')}</p><div className="shop-bonus-tray" />
            <button className="shop-price" disabled={claimed || waiting || status === 'pending'} onClick={claim}>{claimed || waiting ? t('Abgeholt') : status === 'pending' ? t('Wird abgeholt…') : t('Gratis abholen')}</button>
        </div>
        <div className="shop-card-footer" role="status">{waiting ? t('Wieder in {{countdown}}', { countdown }) : claimed ? t('Deinem Spielkonto gutgeschrieben') : status === 'error' ? t('Hat nicht geklappt. Bitte erneut versuchen.') : joker ? t('Wöchentlich · Kostenlos') : daily ? t('Täglich · Kostenlos') : t('Einmalig · Kostenlos')}</div>
    </article>
}
